import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "[generic-check-box]",
  template: `
    <input
      [disabled]="disabled"
      (click)="clickHandler()"
      [ngModel]="isChecked"
      class="generic-checkbox-input"
      type="checkbox"
    />
  `,
  styleUrls: ["./generic-checkbox.component.scss"],
})
export class GenericCheckBoxComponent {
  @Input() public disabled: boolean;
  @Input() public isChecked: boolean;
  @Output() public clickedCheckBox: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  constructor() {}
  public clickHandler() {
    this.clickedCheckBox.emit(!this.isChecked);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/generic-check-box/generic-checkbox.component.ts